import { useEffect } from 'react';
import { setPlays } from '../Home';
import headphones from '../../../assets/headphones.svg';
import { Trans, useTranslation } from 'react-i18next';
import { useSettings } from '../../../context/Settings';
import { DiaTalkLogo } from '@/components/DiaTalkLogo';
import { useLanguageHelper } from '@/utils/language_helper';
import { campusLink } from '../../Navbar/components/menu.helpers';

type AnimationOverlayProps = {
  setPlay: React.Dispatch<boolean>;
  audioCanPlay: boolean;
  audioPlays: boolean;
  audioRef: React.MutableRefObject<HTMLMediaElement | null>;
};

export const Overlay: React.FunctionComponent<AnimationOverlayProps> = ({ setPlay }) => {
  const { t, i18n } = useTranslation();
  const { settings, saveSettings } = useSettings();

  useEffect(() => {
    saveSettings({ showNavLogo: false });
    return () => {
      saveSettings({ showNavLogo: true });
    };
  }, [saveSettings]);

  const a11yHidden = settings.showMenu || !!settings.staticPage;

  const play = () => {
    setPlay(true);
    setPlays(true);
  };

  const { showCampusButton } = useLanguageHelper();
  const campusUrl = campusLink(i18n.language);

  //Fix for font rendering issue in safari
  const buttonStyleOverride = settings.isSafari ? { paddingTop: '20px' } : {};

  return (
    <>
      <div className={`animation-overlay`} aria-hidden={a11yHidden}>
        <div className="intro-center">
          <DiaTalkLogo className="intro-center__logo" aria-label="Dialog Logo" />
          <p>
            <Trans>{t('home.tool_description')}</Trans>
          </p>
          <div className="intro-center__buttons">
            {showCampusButton && (
              <button
                className="intro-center__return-btn"
                onClick={() => (window.location.href = campusUrl)}
                disabled={a11yHidden}
              >
                {t('home.return_to_campus')}
              </button>
            )}
            <button
              className="intro-center__start-btn"
              onClick={play}
              disabled={a11yHidden}
              style={buttonStyleOverride}
            >
              {t('home.start_experience')}
            </button>
          </div>
        </div>
        <div className="headphones-info">
          <img className="headphones-info__logo" src={headphones} alt="headphones icon" />
          <p>{t('home.headphones_recommended')}</p>
        </div>
      </div>
    </>
  );
};
